import { Theme } from "../model";

export const setTheme = (theme: Theme) => {
  document.body.setAttribute("data-theme", theme);
};
